export type LLFonts = {
  /** for fontWeight: 400 (or normal) */
  regular?: string;
  /** for fontStyle: "italic"  */
  italic?: string;
  /** for fontWeight: 100  */
  thin?: string;
  /** for fontWeight: 100 & fontStyle: "italic"  */
  thinItalic?: string;
  /** for fontWeight: 200  */
  extraLight?: string;
  /** for fontWeight: 200 & fontStyle: "italic"  */
  extraLightItalic?: string;
  /** for fontWeight: 300  */
  light?: string;
  /** for fontWeight: 300 & fontStyle: "italic"  */
  lightItalic?: string;
  /** for fontWeight: 500  */
  medium?: string;
  /** for fontWeight: 500 & fontStyle: "italic"  */
  mediumItalic?: string;
  /** for fontWeight: 600  */
  semiBold?: string;
  /** for fontWeight: 600 & fontStyle: "italic"  */
  semiBoldItalic?: string;
  /** for fontWeight: 700  */
  bold?: string;
  /** for fontWeight: 700 & fontStyle: "italic"  */
  boldItalic?: string;
  /** for fontWeight: 800  */
  extraBold?: string;
  /** for fontWeight: 800 & fontStyle: "italic"  */
  extraBoldItalic?: string;
  /** for fontWeight: 900  */
  black?: string;
  /** for fontWeight: 900 & fontStyle: "italic"  */
  blackItalic?: string;
};

export type FontWeightType =
  | 'thin'
  | 'extraLight'
  | 'light'
  | 'regular'
  | 'bold'
  | 'semiBold'
  | 'extraBold'
  | 'black';

export type FontFamilyType =
  | FontWeightType
  | `${FontWeightType}Italic`
  | 'italic';
